import { BrowserRouter, StaticRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Products from "@/components/Products";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import PrivacyPolicy from "./components/privacyPolicy";
import TermsConditions from "./components/termsAndConditions";
import FAQ from "./components/faqs";

export const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <Products />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-conditions" element={<TermsConditions />} />
      <Route path="/faqs" element={<FAQ />} />
    </Routes>
  );
};

function App({ location }) {
  const Router = location ? StaticRouter : BrowserRouter;
  const routerProps = location ? { location } : {};

  return (
    <div className="App">
      <Router {...routerProps}>
        <AppRoutes />
      </Router>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
